// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-cover-button[data-v-54e48b5a]{width:78px;height:20px;line-height:20px;text-align:center;background-color:#df5813;color:#fff;border-radius:10px;margin:12px 0;font-size:12px;cursor:pointer}.cover-box[data-v-54e48b5a]{width:120px;height:75px;-o-object-fit:contain;object-fit:contain;border:1px dashed #979797}", ""]);
// Exports
module.exports = exports;
